// extracted by css-extract-rspack-plugin
export default {"codespaceCard":"tGFjgIVZhgUfFhgo","renderTransparent":"BE6cewnbKy4hUvWz"};